export enum ErrorType {
  OT_USER_MEDIA_ACCESS_DENIED,
  OT_HARDWARE_UNAVAILABLE,
  VIDEO_HARDWARE_NOT_FOUND,
  AUDIO_HARDWARE_NOT_FOUND,
}
